<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.2071 6.70711C18.5976 6.31658 18.5976 5.68342 18.2071 5.29289C17.8166 4.90237 17.1834 4.90237 16.7929 5.29289L11.5 10.5858L6.20711 5.29289C5.81658 4.90237 5.18342 4.90237 4.79289 5.29289C4.40237 5.68342 4.40237 6.31658 4.79289 6.70711L10.0858 12L4.79289 17.2929C4.40237 17.6834 4.40237 18.3166 4.79289 18.7071C5.18342 19.0976 5.81658 19.0976 6.20711 18.7071L11.5 13.4142L16.7929 18.7071C17.1834 19.0976 17.8166 19.0976 18.2071 18.7071C18.5976 18.3166 18.5976 17.6834 18.2071 17.2929L12.9142 12L18.2071 6.70711Z"
      fill="currentColor"
    />
  </svg>
</template>
